module.exports = __webpack_public_path__ + "media/packs/images/flags/LB-fe4a0f57411fbd959992e2568ee78f0f.png";